import { VENDORS_ACTIONS, initialVendorsState } from './vendors.types';
export function vendorsReducer(state = initialVendorsState, action) {
    switch (action.type) {
        case VENDORS_ACTIONS.SET_VENDOR:
            return {
                ...state,
                currentVendor: action.payload
            };
        case VENDORS_ACTIONS.SET_VENDORS:
            return { ...state, data: action.payload };
        case VENDORS_ACTIONS.SET_VENDOR_OPTIONS:
            return { ...state, options: action.payload };
        case VENDORS_ACTIONS.SET_VENDORS_PAGINATED:
            return {
                ...state,
                data: action.payload.vendors,
                pageCount: action.payload.meta.total_pages,
                rowCount: action.payload.meta.total_count
            };
        case VENDORS_ACTIONS.SET_VENDORS_META:
            return {
                ...state,
                pageCount: action.payload.pageCount,
                rowCount: action.payload.rowCount
            };
        case VENDORS_ACTIONS.SET_STATUS:
            return { ...state, status: action.payload };
        case VENDORS_ACTIONS.SET_ERRORS:
            return { ...state, errors: [action.payload, ...state.errors] };
        case VENDORS_ACTIONS.CLEAR_ERRORS:
            return { ...state, errors: [] };
        default:
            return state;
    }
}
